import React from "react";
import { Modal } from "react-bootstrap";

const ConfirmDeleteModal = ({ show, onClose, onConfirm, screenLabels }) => {
  return (
    <Modal show={show} onHide={onClose} centered backdrop="static">
      <Modal.Header closeButton className="py-2">
        <Modal.Title className="h5">
          {screenLabels?.delete_doc_title?.label_value || "Delete Document"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {screenLabels?.delete_doc_confirm?.label_value ||
          "Are you sure you want to delete this document?"}
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-primary fs-15px" onClick={onClose}>
          {screenLabels?.cancel?.label_value || "Cancel"}
        </button>
        <button className="btn btn-danger fs-15px" onClick={onConfirm}>
          {screenLabels?.delete?.label_value || "Delete"}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmDeleteModal;
